<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ this.frequentFlyerID }} - {{ this.frequentflyerName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card v-if="this.requestError == true && this.loading != true">
      <v-card-text>
        <v-row>
          <v-col>
            <v-alert type="error">Error getting Frequent Flyer details.</v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      v-else
      :loading="load"
      :headers="headers"
      :items="data"
      :search="search"
      :sort-by="['AMOUNT']"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, -1],
      }"
      :sort-desc="[true]"
      :items-per-page="10"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      item-key="_id"
      loading-text="Loading data..."
      class="elevation-0 rounded-0"
    >
      <template v-slot:item.AMOUNT="{ item }">
        ${{ item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="px-0">
          <SpecCodes :insurance="insurance" :claimID="item._id" />
        </td>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import SpecCodes from './SpecCodes';

export default {
  name: 'frequentFlyerDetails',
  components: {
    SpecCodes,
  },
  props: [
    'startDate',
    'endDate',
    'value',
    'insurance',
    'frequentFlyerID',
    'frequentflyerName',
    'searchGroups',
    'searchProviders',
    'searchLocations',
    'groups',
    'providers',
    'locations',
  ],
  data() {
    return {
      singleExpand: true,
      expanded: [],
      search: '',
      load: false,
      headers: [
        { text: 'Claim Number', value: '_id' },
        { text: 'Servicer Name', value: 'SERVICER_NAME' },
        { text: 'Start Date', value: 'START_DATE' },
        { text: 'End Date', value: 'END_DATE' },
        { text: 'Amount', value: 'AMOUNT' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      data: [],
    };
  },
  methods: {
    async getFrequentFlyer() {
      this.load = true;
      this.requestError = false;
      this.data = [];

      await axios
        .get(
          `api/modal/frequentflyer/${this.insurance}/${this.frequentFlyerID}/groups=${this.groups}/providers=${providers}/locations=${locations}/${this.startDate}/${this.endDate}/`
        )
        .then((response) => {
          this.data = response.data;
          this.load = false;
        })
        .catch(() => {
          this.requestError = true;
          this.load = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    frequentFlyerID() {
      if (this.frequentFlyerID != null && this.frequentFlyerID != 0 && this.frequentFlyerID != '') {
        this.getFrequentFlyer();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
